import { render, staticRenderFns } from "./H7ComparisonStructuredData.vue?vue&type=template&id=a251e7ca"
import script from "./H7ComparisonStructuredData.vue?vue&type=script&lang=js"
export * from "./H7ComparisonStructuredData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports